import { OrganizationMonitorDefaults } from "@avenueops/shared-types";
import { Organization, WorkflowFrequency, WorkflowSchedule } from "@prisma/client";

export default function getScheduleDefaults(schedule: Omit<WorkflowSchedule, "organizationId"> | undefined, organization: Organization | undefined) {
  const days = schedule?.days;

  // Override with organizationDefaults if those are set
  const organizationDefaults = organization?.monitorSetupDefaults as unknown as OrganizationMonitorDefaults;
  return {
    // Alert Scheduling Properties
    frequency: schedule?.frequency ?? organizationDefaults?.frequency ?? WorkflowFrequency.FIVEMIN,
    hour: schedule?.hour ?? organizationDefaults?.hour ?? 10,
    days: days && days.length > 0 ? days : organizationDefaults?.days ?? [true, true, true, true, true, false, false],

    // Timezone
    timezone: schedule?.timezone ?? organizationDefaults?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,

    // Cron Expression
    cronExpression: schedule?.cronExpression ?? organizationDefaults?.cronExpression ?? undefined,
  };
}
